import { FC, useEffect, useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { Props } from './types'
import { StoresFilter } from '~/entities/stores-filter'
import { useStore } from '~/app/store'

export const CreateCategoryStoresFilter: FC<Props> = observer(
  ({ data = [] }) => {
    const { categoriesStore } = useStore()
    const { setCreateCategoryData, createCategoryData, setIsErrorStoreId } =
      categoriesStore

    const storeId = useMemo(() => {
      return localStorage.getItem('categoryStoreIdFilter')
    }, [])
    const handleChange = (value: string) => {
      setIsErrorStoreId(false)
      setCreateCategoryData({ storeId: value }, 'category')
    }

    useEffect(() => {
      const currentStoreId = createCategoryData?.category?.storeId

      if (!data.length) {
        if (currentStoreId) {
          setCreateCategoryData({ storeId: '' }, 'category')
        }
        return
      }

      if (currentStoreId && data.some((store) => store.id === currentStoreId)) {
        return
      }

      const nextStoreId =
        storeId && data.some((store) => store.id === storeId)
          ? storeId
          : data[0].id

      setIsErrorStoreId(false)
      setCreateCategoryData({ storeId: nextStoreId }, 'category')
    }, [
      createCategoryData?.category?.storeId,
      data,
      setCreateCategoryData,
      setIsErrorStoreId,
      storeId,
    ])

    return (
      <StoresFilter
        data={data}
        selectedStores={[createCategoryData?.category?.storeId]}
        changeStores={handleChange}
      />
    )
  },
)
